import {useRef} from 'react';
export const useConstant = <T>(value: T): T => {
  const constant = useRef<T>(value);
  return constant.current;
};
